import React, { useState, useContext, useEffect } from 'react';
import { getLabels,getRequestAccessLabels } from '../services/LabelsService';
import { useLanguageContext } from './LanguageContext';

const LabelsContext = React.createContext();
const { Provider, Consumer } = LabelsContext;

export const useLabelsContext = () => useContext(LabelsContext);

const LabelsProvider = ({ children }) => {
  const { language } = useLanguageContext();
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [labels, setLabels] = useState({
    buttonContinue: '',
    labelEmailAddress: '',
    labelForgotEmailAddress: '',
    requestAccessUrl:"",
    requestAccessLinkText:"",
    invalidEmail:"",
    account_announcement_title:"",
    account_announcement:"",
    account_announcement_confirmation:"",
    new_account_name: "",
    fail_login_modal_title: "",
    fail_login_modal_content: "",
    fail_login_modal_close: "",
    signin_forgot_email_address_label: "",
    signin_forgot_password_label: "",
    signin_forgot_email_address_tooltip: "",
    reset_password_message: "",
  });

  

  useEffect(() => {
    (async () => {
      const mountLabels = async () => {
        try {
          let resources = await getLabels(language.locale)
          let csLabels = await getRequestAccessLabels(language.locale);
          setLabels({
            ...resources,
            account_announcement_confirmation: csLabels.labels.filter(label => label.key.toLowerCase() === "account_announcement_confirmation")[0]?.value || '',
            account_announcement_title: csLabels.labels.filter(label => label.key.toLowerCase() === "account_announcement_title")[0]?.value || '',
            account_announcement: csLabels.labels.filter(label => label.key.toLowerCase() === "account_announcement")[0]?.value || '',
            buttonContinue: csLabels.labels.filter(label => label.key.toLowerCase() === "signin-button-continue")[0]?.value || '',
            labelEmailAddress: csLabels.labels.filter(label => label.key.toLowerCase() === "signin-email-address")[0]?.value || '',
            gcp_link: csLabels.labels.filter(label => label.key.toLowerCase() === "gcp_link")[0]?.value || '',
            requestAccessUrl: csLabels.labels.filter(label => label.key.toLowerCase() === "public-pages-request-access-link")[0]?.value || '',
            requestAccessLinkText: csLabels.labels.filter(label => label.key.toLowerCase() === "public-pages-request-access")[0]?.value || '',
            invalidEmail: csLabels.labels.filter(label => label.key.toLowerCase() === "public-pages-invalid-email")[0]?.value || '',
            new_account_name: csLabels.labels.filter(label => label.key.toLowerCase() === "new_account_name")[0]?.value || '',
            fail_login_modal_title: csLabels.labels.filter(label => label.key.toLowerCase() === "fail_login_modal_title")[0]?.value || '',
            fail_login_modal_content: csLabels.labels.filter(label => label.key.toLowerCase() === "fail_login_modal_content")[0]?.value || '',
            fail_login_modal_close: csLabels.labels.filter(label => label.key.toLowerCase() === "fail_login_modal_close")[0]?.value || '',
            signin_forgot_email_address_label: csLabels.labels.filter(label => label.key.toLowerCase() === "signin-forgot-email-address-label")[0]?.value || '', 
            signin_forgot_password_label: csLabels.labels.filter(label => label.key.toLowerCase() === "signin-forgot-password-label")[0]?.value || '',
            signin_forgot_email_address_tooltip: csLabels.labels.filter(label => label.key.toLowerCase() === "signin-forgot-email-address-tooltip")[0]?.value || '',
            reset_password_message: csLabels.labels.filter(label => label.key.toLowerCase() === "reset-password-message")[0]?.value || ''
          });

          setIsLoading(false);
    
          setIsError(false);
        } catch (error) {
          console.error('error trying to get labels', error);
    
          setIsError(true);
        }
         
      };
      await mountLabels()
    })()
  }, [language]);

  return <Provider value={{ labels, isLoading, isError }}>{children}</Provider>;
};

export { LabelsProvider, Consumer as ConsumerProvider };      
export default LabelsContext;
